import MapionDatumUtil from '../../config/adapters';

const WalkResult = (
  { naviSearch, setNaviSearch, map, naviToggle,
    naviStart,naviEnd, resultError, setResultError, setIsSmp, naviFromToggle, setNaviURLParam, isTablet}
) => {
  const LINE_WIDTH = 8;
  const LINE_OPACITY = 0.80;
  const LINE_COLOR_WALK = '#00ab1c';
  const WALK_SPEED = 3.2;
  const SCROLL_DELAY_TIME = 300; // SP結果のスクロールで結果の開閉にアニメーションがあるので、それを考慮してスクロールを遅らせる値
  const REACT_APP_API_BLOCK_URL = process.env.REACT_APP_API_BLOCK_URL;

  const meterToKmStr = (distance)=>{
    let numDistance = +distance;
    if(numDistance < 1000){
      return `${numDistance}m`;
    }else{
      let km = Math.ceil(((numDistance / 1000) * 10)) / 10;
      return `${km}km`;
    }
  }

  const hrsMnsToJiFunStr = ({hrs, mns}) => {
    return hrs > 0
      ? `${hrs}時間${mns}分`
      :`${mns}分`;
  }

  // ハンドラ関連
  // 左リストのポイントをクリックで中心に移動する
  const moveCenter = (e, lat, lon) => {
    let {currentTarget} = e;
    const $ = window.$;
    e.preventDefault();
    map.flyTo({center: [lon, lat]})

    if(isTablet){
      naviFromToggle(false, true, true); // SPの場合はフォーム閉じて地図表示しておく
      setTimeout(()=>{
        // SPの場合は選択した要素までスクロールしておく
        let offset = $(currentTarget).offset().top - $(".navi-result-component").offset().top;
        let scrollAmount = $(".navi-result-component").scrollTop();
        $(".navi-result-component").scrollTop(scrollAmount + offset);
      }, SCROLL_DELAY_TIME);
    }
  }

  const fitPointToPoint = (e) => {
    let {currentTarget} = e;
    const $ = window.$;
    let {lat: firstLat, lon: firstLon} = $(currentTarget).prev().data();
    let {lat: lastLat, lon: lastLon} = $(currentTarget).next().data();

    // 必ず min=西南 max=北東 にする ※これやらないとfitboundsでバグる
    let minLat = firstLat < lastLat? firstLat: lastLat;
    let minLon = firstLon < lastLon? firstLon: lastLon;
    let maxLat = firstLat > lastLat? firstLat: lastLat;
    let maxLon = firstLon > lastLon? firstLon: lastLon;

    let padding =  {top: 100, left: 500, bottom: 100, right:40};
    if(isTablet){
      padding=  {top: 160, left: 30, bottom: 260, right:80}; // SPの場合は範囲が狭いので余白を変える※上下左右の対象同士の値が画面の範囲を超えると全くうごかなくなるので
      naviFromToggle(false, true, true); // SPの場合は地図表示しておく
      setTimeout(()=>{
        // SPの場合は選択した要素までスクロールしておく
        let offset = $(currentTarget).offset().top - $(".navi-result-component").offset().top;
        let scrollAmount = $(".navi-result-component").scrollTop();
        $(".navi-result-component").scrollTop(scrollAmount + offset);
      }, SCROLL_DELAY_TIME);
    }

    map.fitBounds([[minLon, minLat], [maxLon, maxLat]],{
      padding
    });
  }

  const execSearch = () => {
    // ルート検索実行処理
    // パラメータを作る
    let params = Object.keys(naviSearch.walk).map(key => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(naviSearch.walk[key])}`;
    });
    var start = naviStart;
    let {x: startX, y: startY} = MapionDatumUtil.wgs.tky({y: start.lat, x: start.lon});
    params.push(`sty=${startY}`);
    params.push(`stx=${startX}`);
    var end = naviEnd;
    let {x: endX, y: endY} = MapionDatumUtil.wgs.tky({y: end.lat, x: end.lon});
    params.push(`edy=${endY}`);
    params.push(`edx=${endX}`);
    params.push(`datum=TOKYO`);

    let url = `${REACT_APP_API_BLOCK_URL}/map/uc/SearchRoute?${params.join('&')}`;
    if(!window.jqXHR) { // まだリクエストが走っていない場合のみ実行
      window.jqXHR = window.$.ajax({
        url: url,
        dataType: 'jsonp',
        jsonpCallback: 'searchRouteCallback',
        success: function({searchRoute}) {
          let {pointList:{point}} = searchRoute;
          let geojson = null;
          if(point){
            let coordinates = point.map(({el, nl})=>{ 
              let {y, x} = MapionDatumUtil.tky.wgs({y: nl, x: el})
              return [x, y];
            });
            let polyLineFeatures = [{ // geoJSONのポリラインを生成する
              type: "Feature",
              properties: {
                "stroke": LINE_COLOR_WALK,
                "stroke-width": LINE_WIDTH,
                "stroke-opacity": LINE_OPACITY
              },
              geometry: {
                type: "LineString",
                coordinates
              }
            }];

            geojson = { // geojsonと言いながらfeaturesで区別する ※maplibreのpolylineとpointは区別してレンダリングしかできないため
              polyLineFeatures
            };

            if(isTablet){
              setIsSmp(true);
            }
            setNaviSearch({ ...naviSearch, walkResult:geojson, walkResultData:searchRoute, searchResultError: false});
            setResultError("");

            setTimeout(()=>{
              window.$(".navi-result-component").scrollTop(0); // 結果のスクロール位置をTOPに戻す
            }, SCROLL_DELAY_TIME);
          } else {
            // 徒歩ルートの制限距離(5km以上)を超えた場合はエラーメッセージで注意を促す
            setResultError("walklimit");
          }
          // 結果URLパラメータをセット
          setNaviURLParam();
        },
        error: function(xhr, status, error) {
          console.error("ルート検索エラー:", error);
          setResultError("walkAPIError");
        }
      }).always(function() {
        window.jqXHR = null;
      });
    }
  }

  let {walkResult} = naviSearch;

  if(naviSearch.reSearchFlag){ // 再検索フラグがある場合(※ルート検索ボタンが押下されたら場合などにフラグが立つ)
    // 検索結果を削除して次のレンダー(再帰)で再検索する
    setNaviSearch({ ...naviSearch, walkResult: null, walkResultData: null, resultRendered: false, reSearchFlag: false });
  }

  // データがなく、エラーがないときは検索を実行する
  if(!walkResult && resultError === ""){
    execSearch();
    return (
      <div className="navi-result-component">
        読み込み中
      </div>
    ); // 徒歩ルートの距離の制限が超えてる場合はエラーメッセージを表示する
  } else if(resultError === "walklimit"){
    return (
      <div className="navi-result-component">
        距離が徒歩ルートの制限を越えました。<br/>着の距離を狭めるか、車・駅で検索してください。
      </div>
    );
  } else if(resultError === "walkAPIError"){
    return (
      <div className="navi-result-component">
        徒歩ルートの検索が失敗しました。時間を置いてから再度検索してください。
      </div>
    );
  }

  // 検索結果がある場合は結果をリスト表示する
  let sumDistance = "";
  let durationString = "";
  if(naviSearch.walkResultData){
    let {walkResultData:{property:{tdist}}} = naviSearch;
    let necessaryTime =  Math.round((+tdist) / ((WALK_SPEED * 1000) / 60)); // walkResultData.property.necessaryTime で時間を取得できるが乗り換え徒歩と時間が合うようにあえて計算している
    let hrs = Math.floor(necessaryTime/60);
    let mns = necessaryTime % 60;
    durationString = hrsMnsToJiFunStr({hrs, mns})
    sumDistance = meterToKmStr(tdist);
  }
  var {name: startName, lat:startLat, lon: startLon} = naviStart;
  var {name: endName, lat:endLat, lon:endLon} = naviEnd;

  return (
    <div className="navi-drive-result">
      <div className="navi-info-wrapper" onClick={()=> naviToggle(true)}>
      <div className="navi-info">
        <div className="navi-info-wrap">
          <div className="navi-info-left">
            <div className="navi-info-num">経路</div>
            <div className="navi-info-icon"><span className="navi-list-walk"></span></div>
          </div>
          <div className="navi-info-right">
            <div className="navi-info-time">{durationString}<span className="navi-info-sub">（{sumDistance}）</span></div>
          </div>
        </div>
      </div>
      </div>
      <div className="navi-route">
        <div className="navi-spot navi-spot-start" data-lat={startLat} data-lon={startLon}>
          <p className="navi-spot-icon"><span className="navi-icon-inner">発</span></p>
          <p onClick={(e)=> moveCenter(e, startLat, startLon)} className="navi-spot-name"><a onClick={(e)=> e.preventDefault()} href="#" data-lat={startLat} data-lon={startLon}>{startName}</a></p>
        </div>
        <div className="navi-line navi-line-walk" onClick={fitPointToPoint}>
          <p className="navi-line-time">{durationString}</p>
          <div className="navi-line-icon">
            <span className="navi-icon-inner"></span>
          </div>
          <p class="navi-line-name">徒歩（{sumDistance}）</p>
        </div>
        <div className="navi-spot navi-spot-end" data-lat={endLat} data-lon={endLon}>
          <p className="navi-spot-icon"><span className="navi-icon-inner">着</span></p>
          <p onClick={(e)=> moveCenter(e, endLat, endLon)} className="navi-spot-name"><a onClick={(e)=> e.preventDefault()} href="#" data-lat={endLat} data-lon={endLon}>{endName}</a></p>
        </div>
      </div>
    </div>
  );
};

export default WalkResult;
